import {
  enforceEmailVerification,
  hasEmailVerificationRedirect
} from '~/utils/emailVerification'

/**
 * PLATFORM-184: client-only. The identified user's PostHog flags usually
 * arrive after the router middleware has run (identify happens in Navbar), so
 * re-run the enforcement whenever flags load. Also reloads on a bfcache
 * restore so the back button cannot show the gated page.
 *
 * @param {object} ctx - Nuxt plugin context.
 * @param {object} ctx.app - Nuxt app (carries $auth, $posthog and $cookies).
 */
export default function({ app }) {
  if (app.$posthog && process.env.POSTHOG_DISABLE_FEATURE_FLAGS !== 'true') {
    app.$posthog.onFeatureFlags(() => {
      enforceEmailVerification({
        $auth: app.$auth,
        $posthog: app.$posthog,
        $cookies: app.$cookies
      })
    })
  }

  window.addEventListener('pageshow', event => {
    if (event.persisted && hasEmailVerificationRedirect()) {
      window.location.reload()
    }
  })
}
